export const questions = [
    {key: "pet", label: "What is your pet's name?"},
    {key: "color", label: "What is your favorite color?"},
    {key: "mother", label: "What is your mother's maiden name?"},
    {key: "food", label: "What is your favorite food?"},
    {key: "firstpet", label: "What was your first pet's name?"},
    {key: "school", label: "What was the name of your first school?"},
    {key: "movie", label: "What is your favorite movie?"},
  ];